<iframe id="webglFrame" class="externalSceneContainer" (webglInit)=onWebglInit($event) [src]="iframeSrc | safe" (load)="webglLoaded()" title="WebGL Frame"></iframe>
